import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { LoadingButton } from '@mui/lab'
import { Box, Button } from '@mui/material'
import Grid from '@mui/material/Grid2'

import API from '../../../data/api';
import CustomModal from '../../custom/CustomModal'
import FileDragzone from '../../ui/FileDragzone'
import { extractFormValues, isNullValue, validateForm } from 'src/utils/formUtil'
import { MAX_FILE_SIZE_MB } from 'src/utils/constants';
import CustomDatePicker from 'src/components/custom/CustomDatePicker';
import { useSnackbar } from 'src/contexts/SnackbarContext';

const initFormState = {
  startDate: { value: null, required: true, error: false, errorMessage: 'Please specify a start date' },
  endDate: { value: null, required: true, error: false, errorMessage: 'Please specify an end date' },
  fileObjects: {
    value: [], required: true, error: false, errorMessage: 'Please select required file'
  }
}

const WeeklySalesReport = ({
  openModal,
  handleCloseModal,
  handleSubmitCallback,
}) => {

  const {showSnackbar} = useSnackbar();

  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({ ...initFormState });

  useEffect(() => {

  }, [openModal]);

  const handleSubmitReport = async () => {

    if ( formData.fileObjects[0] === null || formData.fileObjects.length === 0
      || !validateForm(setFormData, formData)) {
      notifyError("Pleae ensure all required inputs are provided");
      return;
    }

    const {startDate, endDate } = extractFormValues(formData);
    let endPoint = `analytics/sales/upload_weekly_report`
        .concat(`?time_start=${startDate}`)
        .concat(`&time_end=${endDate}`);

    const payload = new FormData();
    payload.append('file', formData.fileObjects[0]);

    setSubmitted(true);
    try {
      const res = await API.post(`${endPoint}`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (res.status === 200 || res.status === 201) {
        showSnackbar({
          message: `Successfully uploaded a sales report, dated from ${startDate} to ${endDate}`,
        });
        handleSubmitCallback();
      } else {
        notifyError("System encountered an error uploading a sales report");
      }
    } catch (error) {
      notifyError("An unexpected error occurred. Please try again.");
    }
    setSubmitted(false);
  }

  const notifyError = (message) => {
    showSnackbar({
      message: message,
      type: "error",
    });
  }

  const handleResetAndClose = () => {
    setFormData({ ...initFormState });
    handleCloseModal({ isOpen: false, updateStats: null });
  }

  const handleFileObjects = (files) => {
    const file = (files.length > 0) ? files[0] : null;
    setFormData({
      ...formData,
      fileObjects: files,
      filePreviewUrl: (file ? URL.createObjectURL(file) : null),
    })
  };

  const updateFiledValue = (field, value, data) => {
    const currentData = data || formData;

    const newFormData = {
      ...currentData,
      [field]: {
        value: value,
        error: isNullValue(value),
      },
    };
    setFormData(newFormData);

    return newFormData;
  }

  return (
    <CustomModal
      openModal={openModal}
      handleCloseModal={handleResetAndClose}
      modalTitle={"Weekly Sales Report"}
      modalIcon='document'
    >
      <Box sx={{ my: 2 }}>
        <Grid container spacing={2.5} sx={{ my: 2 }}>
          <Grid item xs={2} >
            <CustomDatePicker sx={{ overflow: 'hidden' }}
              label={"Start Date"}
              field={'startDate'}
              disableFuture={true}
              disablePast={false}
              currentValue={formData.startDate.value}
              handleChange={updateFiledValue}
              clear={true}
              setClear={()=>console.log()}
              dateError={formData.startDate.error && 'invalidDate'}
            />
          </Grid>
          <Grid item xs={2} >
            <CustomDatePicker sx={{ overflow: 'hidden' }}
              label={"End Date"}
              field={'endDate'}
              disableFuture={true}
              disablePast={false}
              currentValue={formData.endDate.value}
              handleChange={updateFiledValue}
              clear={true}
              setClear={()=>console.log()}
              minDate={formData.startDate.value}
              dateError={formData.endDate.error && 'invalidDate'}
            />
          </Grid>
        </Grid>
        <FileDragzone
          acceptedTypes={{
            "text/csv": [".csv"],
            "application/vnd.ms-excel": [".xls"],
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
          }}
          fileObjects={formData.fileObjects}
          handleFileObjects={handleFileObjects}
          filesLimit={1}
          maxFileSizeMB={MAX_FILE_SIZE_MB}
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'right', mt: 2 }}>
        <Button
          variant='contained'
          color="inherit"
          onClick={() => handleResetAndClose()}
          disabled={submitted}
        >
          Cancel
        </Button>
        <LoadingButton
          sx={{ ml: 2, }}
          variant="contained"
          onClick={() => handleSubmitReport()}
          loading={submitted}
        >
          Submit
        </LoadingButton>
      </Box>
    </CustomModal>
  )
}

WeeklySalesReport.propTypes = {
  /** Flag to toggling openning of modal */
  openModal: PropTypes.bool,

  /** Callback function when closing modal */
  handleCloseModal: PropTypes.func.isRequired,

  /** Callback function after assignment of suborder to clients */
  handleSubmitCallback: PropTypes.func.isRequired,
}

export default WeeklySalesReport